import { render, staticRenderFns } from "./CalculateBoxItem.vue?vue&type=template&id=28c51ef2&"
import script from "./CalculateBoxItem.vue?vue&type=script&lang=js&"
export * from "./CalculateBoxItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports